import { render, staticRenderFns } from "./radiogroup.vue?vue&type=template&id=06c6d526&"
import script from "./radiogroup.vue?vue&type=script&lang=ts&"
export * from "./radiogroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c6d526')) {
      api.createRecord('06c6d526', component.options)
    } else {
      api.reload('06c6d526', component.options)
    }
    module.hot.accept("./radiogroup.vue?vue&type=template&id=06c6d526&", function () {
      api.rerender('06c6d526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/radiogroup.vue"
export default component.exports